import { Pipe, PipeTransform } from '@angular/core';

import { DatePipe } from '@angular/common';

@Pipe({
  name: 'transformItineraryDate',
  standalone: false,
})
export class TransformItineraryDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform({ Port, StartDate, EndDate }): string {
    const isAtSea = Port?.toLowerCase() === 'at sea';
    const startDate = this.datePipe.transform(StartDate, 'dd MMMM yyyy');
    const endDate = this.datePipe.transform(EndDate, 'dd MMMM yyyy');
    const atSeaTime = EndDate ? `${startDate} - ${endDate}` : startDate;

    return isAtSea ? `${atSeaTime}` : startDate;
  }
}
